"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var theme_1 = __importDefault(require("../../../styles/theme"));
var makeStyles_1 = __importDefault(require("../../../util/makeStyles"));
var styleUtilities_1 = require("../../../util/styleUtilities");
var useStyles = (0, makeStyles_1.default)(function () {
    return (0, core_1.createStyles)({
        root: {
            backgroundColor: (0, styleUtilities_1.withOpacity)(theme_1.default.colors.dark, 0.08),
            borderRadius: 4,
            display: 'grid',
            gap: 8,
            gridTemplateColumns: '20px auto fit-content(100%)',
            padding: '8px 16px',
            width: '100%',
            minHeight: 40,
            alignItems: 'center',
        },
        iconWrapper: {
            display: 'flex',
            alignItems: 'center',
        },
        messageRoot: __assign(__assign({}, theme_1.default.fonts.label1), { wordBreak: 'break-word' }),
    });
});
exports.default = useStyles;
